import dynamic from 'next/dynamic';
import React, { FC, ReactNode } from 'react';

const MediaQuery = dynamic(() => import('react-responsive'), {
  ssr: false,
});

const MaxAndMediumScreen: FC<{ children: ReactNode }> = ({ children }) => {
  return <MediaQuery minWidth={1024}>{children}</MediaQuery>;
};

export default MaxAndMediumScreen;
